import React from 'react';
import '../root.css';
import '../css/DetekcegptPage.css';
import SEO from '../components/SEO';

function DetekcegptPage() {
  return (
    <>
      <SEO
        title="DetekceGPT - AI Content Detection SaaS | Samuel Banczík"
        description="DetekceGPT is an AI-powered B2C SaaS platform built by Samuel Banczík that detects AI-generated content in pasted text or uploaded documents, scores and highlights suspicious passages and humanizes them."
        keywords="DetekceGPT, AI detector, AI content detection, ChatGPT detector, AI text humanizer, Samuel Banczík"
        url="https://banczik.com/detekcegpt"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "DetekceGPT",
          // The entity lives on its own domain; this page only describes it.
          "url": "https://detekcegpt.cz",
          "sameAs": "https://detekcegpt.cz",
          "mainEntityOfPage": "https://banczik.com/detekcegpt",
          "applicationCategory": "UtilitiesApplication",
          "operatingSystem": "Web",
          "author": {
            "@type": "Person",
            "name": "Samuel Banczík",
            "url": "https://banczik.com"
          },
          "description": "AI-generated content detection and humanization tool",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://banczik.com/" },
              { "@type": "ListItem", "position": 2, "name": "DetekceGPT", "item": "https://banczik.com/detekcegpt" }
            ]
          }
        }}
      />
      <div>DetekcegptPage</div>
    </>
  )
}

export default DetekcegptPage
